export default {
  logo: require('../assets/images/logo.png'),
  logo2x: require('../assets/images/logo@2x.png'),
  logo3x: require('../assets/images/logo@3x.png'),
  btnPlay: require('../assets/images/play.svg'),
  favicon: require('../assets/images/favicon.ico'),
  bgProcess: require('../assets/images/bg-process.jpg'),
  quoteLeft: require('../assets/images/quote-left.png'),
  quoteRight: require('../assets/images/quote-right.png'),
  team: require('../assets/images/team.jpg'),
  teamDesign: require('../assets/images/team-design.jpg'),
  teamGame: require('../assets/images/team-game.jpg'),
  aboutUsDesign: require('../assets/images/about-us-design.jpg'),
  aboutUsGame: require('../assets/images/about-us-game.jpg'),
  thumbnailBanner: require('../assets/images/thumbnail-banner.jpg'),
  poster: require('../assets/images/poster.jpg'),
  ideate: require('../assets/images/team-collaboration-1.jpg'),
  design: require('../assets/images/team-collaboration-2.jpg')
}



// WEBPACK FOOTER //
// ./src/themes/Image.js